import type { SVGProps } from 'react';
import { AnimalFace } from './AnimalFace';

export function AnimalRoe(props: SVGProps<SVGSVGElement>) {
  return (
    <AnimalFace size={150} {...props}>

  <>
    <path
      d="M29.522 29.747c-7.574-4.332-20.318-6.304-28.049-4.012-2.211 1.66 3.928 11.493 6.102 13.788C19.027 51.63 30.02 56.227 45.904 54.974c-1.5-14.719-8.807-20.893-16.382-25.226z"
      fill="#E79335"
    />
    <path
      d="M42.123 52.469C35.384 42.909 20.99 34.87 8.755 33.038c6.494 12.007 22.396 18.653 33.368 19.43z"
      fill="#2F2E27"
    />
    <path
      d="M105.229 54.59c6.906.047 13.886.09 20.615-1.406 6.727-1.496 13.282-4.696 17.407-10.018 4.157-5.362 5.448-12.293 5.749-18.973-37.2.23-43.771 30.396-43.771 30.396z"
      fill="#E79335"
    />
    <path
      d="M111.455 52.852c6.222-1.358 12.448-2.85 18.136-5.604 6.338-3.07 12.04-7.9 14.575-14.268-12.324 4.042-23.576 10.956-32.711 19.872z"
      fill="#2F2E27"
    />
    <path
      d="M110.804 57.162c-7.652-14.48-26-22.838-42.555-19.591-16.556 3.251-30.888 14.078-31.68 33.838-1.02 25.497 10.553 46.32 17.545 59.3.023-2.538.568-5.154 1.811-7.649 4.2-8.44 17.915-11.008 27.859-7.808 5.908 1.906 11.496 6.17 13.86 12.474.531 1.418.806 2.914.9 4.419 4.581-9.539 11.631-23.081 15.83-44.133 2.064-10.343 1.394-21.463-3.57-30.85"
      fill="#E79335"
    />
    <path
      d="M108.172 83.293c1.084-7.813.786-24.382-3.478-34.218-9.155-9.28-23.32-14.074-36.445-11.502-6.51 1.28-12.632 3.775-17.766 7.476-7.363 10.715-6.575 31.33-3.595 42.477 2.909 10.879 10.27 20.797 11.874 31.927 5.818-5.457 16.703-6.875 25.021-4.199 3.588 1.159 6.96 3.282 9.66 6.105 4.292-11.886 13.035-25.86 14.729-38.066"
      fill="#FBDDA9"
    />
    <path
      d="M68.249 37.574c-4.824.947-9.432 2.572-13.587 4.851-3.418 6.092-3.649 11.19-.88 17.598 2.848 6.59 9.786 15.124 11.715 22.016 1.768 6.317-.542 12.933-2.174 19.284-1.281 4.986-1.984 10.572-.215 15.242 6.009-2.949 14.121-3.421 20.676-1.311a22.727 22.727 0 015.144 2.422c.768-1.172 1.409-2.413 1.851-3.727 4.26-12.634-3.006-18.727-3.006-32.005 0-5.698 6.89-12.526 11.407-21.921 1.55-3.226 2.925-8.47 1.912-14.165-9.03-7.13-21.334-10.541-32.843-8.284"
      fill="#945821"
    />
    <path
      d="M112.446 87.665c-1.257-2.4-4.083-4.042-6.859-3.718-2.778.329-5.192 2.789-5.098 5.474.096 2.69 1.41 5.387 7.5 5.534 1.598.04 3.254-.614 4.234-1.829 1.227-1.517 1.122-3.744.223-5.46zM50.264 88.543c-3.196-1.912-8.192-.614-9.556 2.758-3.744 9.257 9.027 9.595 11.32 6.728 2.294-2.871 1.434-7.575-1.764-9.486"
      fill="#ED715C"
    />
    <path
      d="M52.791 79.095c-2.081-1.189-5.604.908-5.604 4.406 0 2.21.905 5.651 3.871 6.084 2.966.432 3.71-4.895 3.613-6.222-.116-1.587-.382-3.412-1.88-4.268M106.839 78.907c-.2-.834-.647-1.725-1.666-2.118-1.447-.563-3.315.242-3.971 1.34-.657 1.098-2.191 8.88 2.358 8.643 4.549-.242 3.951-5.063 3.279-7.865z"
      fill="#1F1611"
    />
    <path
      d="M97.643 127.73c-2.363-6.304-7.951-10.567-13.86-12.474-9.944-3.2-23.658-.631-27.858 7.809-3.546 7.121-1.686 15.224 3.054 19.686 6.49 6.114 23.276 8.967 33.597 2.447 5.334-3.373 7.43-11.168 5.067-17.468"
      fill="#FEECCE"
    />
    <path
      d="M77.124 116.686c-2.143-.13-6.392.139-8.367.934-1.974.8-4.131 1.5-3.695 4.562.438 3.065 5.978 6.926 12.715 6.407 6.735-.523 8.284-2.858 9.451-5.011 1.592-2.94-1.52-6.369-10.104-6.892"
      fill="#E6867B"
    />
    <path
      d="M89.293 121.351c-.776-.428-1.77-.074-2.535.372-2.815 1.643-2.244 6.381-9.11 6.187-6.864-.195-8.8-5.007-9.317-5.803-.519-.791-1.222-1.535-2.159-1.837-.937-.303-2.132-.035-2.603.782-.47.822.599 6.745 11.132 8.025 2.98.363 5.094.329 8.003-.376 2.91-.7 6.57-2.11 7.29-4.851.237-.895.148-2.028-.7-2.499"
      fill="#1F1611"
    />
    <path
      d="M90.237 135.826c-2.23 3.869-6.921 5.932-11.822 6.269 1.007-4.22 1.027-8.535.47-12.824-.588.026-1.26-.043-1.868-.069.61 4.302.575 8.677-.511 12.902-4.669-.117-9.277-1.751-11.901-5.076-.722-.913-2.354-.018-1.621.912 6.546 8.289 23.468 8.176 28.875-1.206.587-1.017-1.035-1.929-1.621-.908zM50.567 2.001c3.228 6.451-2.306 15.116-3.712 18.947-4.343 11.838-.659 19.444 10.225 25.359 5.057 3.49 9.628-3.732 7.574-5.024C44.098 28.359 69.57 12.806 50.567 2M108.441 24.193c-1.912-9.711-6.074-16.487-2.098-21.61-11.678 4.155-7.87 12.171-8.921 24.04-.7 7.9-3.1 10.982-7.792 14.7-1.88 1.54-1.042 4.532 2.191 6.257 3.233 1.725 4.789.692 7.027-1.172 7.617-8.115 11.602-12.015 9.593-22.215"
      fill="#1F1611"
    />
    <path fill="#fff" fillOpacity={0.01} d="M149 149h1v1h-1z" />
  </>
    </AnimalFace>
  );
}
